import TourView from './TourView';
export default TourView;
